import { render, staticRenderFns } from "./RewardSearchAlive.vue?vue&type=template&id=473d0d5d&"
import script from "./RewardSearchAlive.vue?vue&type=script&lang=js&"
export * from "./RewardSearchAlive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports